import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Send = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.762 12.409L9.972 4.52C9.372 4.18 8.69 4 8 4C5.794 4 4 5.794 4 8V11C4 13.085 5.069 14.924 6.687 16C5.069 17.076 4 18.916 4 21V24C4 26.206 5.794 28 8 28C8.69 28 9.372 27.82 9.972 27.48L25.753 19.595C27.118 18.929 28 17.518 28 16C28 14.482 27.118 13.07 25.762 12.409V12.409ZM24.868 17.802L9.053 25.704C9.035 25.713 9.017 25.722 9 25.733C8.696 25.908 8.351 26.001 8 26.001C6.897 26.001 6 25.104 6 24.001V21.001C6 18.795 7.794 17.001 10 17.001H17C17.552 17.001 18 16.553 18 16.001C18 15.449 17.552 15.001 17 15.001H10C7.794 15.001 6 13.207 6 11.001V8.001C6 6.898 6.897 6.001 8 6.001C8.351 6.001 8.696 6.094 9 6.269C9.017 6.279 9.035 6.288 9.053 6.298L24.877 14.204C25.559 14.537 26 15.242 26 16.001C26 16.76 25.559 17.466 24.868 17.803V17.802Z" />
	</svg>
);

export default Send;
